import { StatusBar as NbStatusBar } from '@fhs-legacy/native-base';

import { addWithConfig } from '../../utils';

export const StatusBar = NbStatusBar;

export default addWithConfig(StatusBar);
